import React from "react";
let PropTypes = React.PropTypes;
// API
import api from "../../../apiClient/v1";
// CSS
import * as css from "../modal.css";
// Componentes
import { AutoSizer, Table, Column } from "react-virtualized";

export class DetalleProgramacionAG extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      idCliente: "0",
      cutRegion: "0",
      clientes: this.props.clientes,
      regiones: this.props.regiones,
      fechaInicio: this.props.fechaInicio,
      fechaFin: this.props.fechaFin,
      detalle: [],
      dividir: false,
      isLoading: true,
    };
    this.fetchDetalle = () => {
      this.setState({ detalle: [] });
      this.setState({ isLoading: true });
      api.auditoria
        .getDetalle(
          this.state.fechaInicio,
          this.state.fechaFin,
          this.state.idCliente,
          this.state.cutRegion
        )
        .then((detalle) => {
          const longitud = detalle.auditorias.length;
          const ordenadasPorFecha = detalle.auditorias.sort(
            (a, b) => new Date(a.fechaProgramada) - new Date(b.fechaProgramada)
          );
          const total = {
            fechaProgramadaDia: "Total",
            totalAG: Math.round(
              ordenadasPorFecha.reduce((prev, curr) => prev + curr.totalAG, 0)
            ),
            totalOBL: Math.round(
              ordenadasPorFecha.reduce((prev, curr) => prev + curr.totalOBL, 0)
            ),
          };
          const promedio = {
            fechaProgramadaDia: "Promedio",
            totalAG: Math.round(total.totalAG / longitud),
            totalOBL: Math.round(total.totalOBL / longitud),
          };
          if (ordenadasPorFecha.length > 0) {
            ordenadasPorFecha.push(promedio);
            ordenadasPorFecha.push(total);
          }
          this.setState({
            detalle: ordenadasPorFecha,
          });
          this.setState({ isLoading: false });
        })
        .catch((meh) => {
          this.setState({ isLoading: false });
        });
    };
    this.seleccionarRegion = (evt) => {
      const cutRegion = evt.target.value;
      this.setState(
        {
          cutRegion: cutRegion,
          detalle: [],
        },
        () => {
          this.fetchDetalle();
        }
      );
    };
  }
  renderDivisionTablas() {
    return (
      <div className="row">
        <div className="col-md-6">
          <Detalle detalle={this.state.coleccionUno} />
        </div>
        <div className="col-md-6">
          <Detalle detalle={this.state.coleccionDos} />
        </div>
      </div>
    );
  }
  renderTablaNormal() {
    return (
      <div className="row">
        <div className="col-md-12">
          <Detalle
            detalle={this.state.detalle}
            isLoading={this.state.isLoading}
          />
        </div>
      </div>
    );
  }
  componentWillMount() {
    this.fetchDetalle();
  }
  render() {
    return (
      <div className="container-fluid">
        <div className="row">
          <SelectorRegion
            idRegionSeleccionada={this.state.idRegion}
            seleccionarRegion={this.seleccionarRegion}
            regiones={this.state.regiones}
          />
        </div>
        {this.state.dividir
          ? this.renderDivisionTablas()
          : this.renderTablaNormal()}
      </div>
    );
  }
}
const Detalle = ({ detalle, isLoading }) => {
  const Tabla = () => {
    if (detalle.length > 0) {
      return (
        <AutoSizer>
          {({ height, width }) => (
            <Table
              // general
              height={height}
              width={width}
              // headers
              headerHeight={30}
              headerClassName={css.headerColumn}
              // rows
              rowCount={detalle.length}
              rowGetter={({ index }) => detalle[index]}
              rowHeight={30}
              rowClassName={({ index }) =>
                index < 0
                  ? css.headerRow
                  : index % 2 === 0
                  ? css.evenRow
                  : css.oddRow
              }
            >
              {/* FECHAS */}
              <Column
                dataKey="fechaProgramadaDia"
                label="Fechas"
                cellRenderer={({
                  cellData,
                  columnData,
                  dataKey,
                  rowData,
                  rowIndex,
                }) => rowData[dataKey]}
                width={145}
              />
              <Column
                dataKey="totalAG"
                label="Total AG"
                cellRenderer={({
                  cellData,
                  columnData,
                  dataKey,
                  rowData,
                  rowIndex,
                }) => rowData[dataKey]}
                width={145}
              />
              {/* SUMA*/}
              <Column
                dataKey="totalOBL"
                label="OBLIGATORIOS"
                cellRenderer={({
                  cellData,
                  columnData,
                  dataKey,
                  rowData,
                  rowIndex,
                }) => rowData[dataKey]}
                width={120}
              />
            </Table>
          )}
        </AutoSizer>
      );
    } else {
      return (
        <div
          className="col-md-12 bg-warning"
          style={{
            padding: "20px",
            fontWeight: "bold",
            marginLeft: "15px",
            marginRight: "15px",
          }}
        >
          No se encontraron auditorias en este rango de fechas
        </div>
      );
    }
  };
  const TablaLoading = () => (
    <div
      className="col-md-12 bg-warning"
      style={{
        padding: "20px",
        fontWeight: "bold",
        marginLeft: "15px",
        marginRight: "15px",
      }}
    >
      Cargando...
    </div>
  );

  return (
    <div style={{ height: "100%" }} className="row">
      {isLoading ? <TablaLoading /> : <Tabla />}
    </div>
  );
};

const SelectorRegion = ({
  idRegionSeleccionada,
  seleccionarRegion,
  regiones,
}) => (
  <div className="col-sm-2 form-group ">
    <label className="control-label" htmlFor="cliente">
      Regiones
    </label>
    <select
      className="form-control"
      name="regiones"
      value={idRegionSeleccionada}
      onChange={seleccionarRegion}
    >
      <option value="0">Todas</option>
      {regiones.map((region) => (
        <option
          key={region.cutRegion}
          value={region.cutRegion}
        >{`${region.nombreCorto}`}</option>
      ))}
    </select>
  </div>
);

DetalleProgramacionAG.propTypes = {
  regiones: PropTypes.arrayOf(PropTypes.object).isRequired,
  clientes: PropTypes.arrayOf(PropTypes.object).isRequired,
};



// WEBPACK FOOTER //
// ./frontEnd/auditorias/programacion-semanal/Detalle/DetalleProgramacionAG.jsx